<script setup>
import {onMounted} from "vue";
import forestreeHelpers from "@/helpers/forestreeHelpers";

const props = defineProps([
    "permissions",
    "storm_mode",
    "activeStorms"
]);


onMounted(() => {
});


</script>

<template>
            <div v-if="storm_mode" 
                :class="activeStorms.length > 0 ? 'bg-slate-700' : 'bg-white'"    
                class="mt-3 h-auto text-slate-600 forestree-box all-rounded w-full py-6 px-4">
                <div class="flex items-center pb-1">
                    <img src="/images/icons/storm.png" class="h-6 w-6 mr-1" />
                    <p class="uppercase font-semibold" :class="activeStorms.length > 0 ? 'text-white' : 'text-slate-600'">Storm Mode</p>
                </div>

                <div v-if="activeStorms && activeStorms.length === 0">
                    <p class="text-slate-500 text-sm pt-1 pl-1 text-left">No active storms</p>
                </div>

                <div v-if="activeStorms && activeStorms.length > 0">
                    <div v-for="storm in activeStorms" :key="storm.id" class="py-3 px-2 bg-white rounded-lg my-2">
                        <div class="flex justify-between items-center py-1">
                            <div class="flex items-center">
                                <div class="flex-none rounded-full bg-emerald-500/20 p-1">
                                    <div class="size-1.5 rounded-full bg-emerald-500" />
                                </div>
                                <!-- <img src="/images/icons/storm.png" class="h-6 w-6 mr-2" /> -->
                                <div>
                                    <p class="text-slate-800 pl-1 font-semibold">{{ storm.name }}</p>
                                    <p class="text-slate-400 pl-1 font-semibold text-xs">Active</p>
                                </div>
                            </div>
                            <div class="flex items-center">
                                <p class="text-slate-800 text-sm">{{ forestreeHelpers.justDate(storm.start_date) }}</p>
                            </div>
                        </div>
                        <div class="w-full pt-2">
                            <div class="flex justify-between">
                                <div class="w-full pr-1">
                                    <a
                                        v-if="permissions && permissions.storm_list"
                                        :href="'/storms?list=true&stormId=' + storm.id"
                                        class="w-full flex justify-center cursor-pointer uppercase text-white font-semibold text-center py-3 bg-slate-600 hover:bg-slate-500 rounded-lg"
                                    >
                                        LIST
                                    </a>
                                </div>
                                <div class="w-full pl-1">
                                    <a
                                        v-if="permissions && permissions.storm_map"
                                        :href="'/storms?map=true&stormId=' + storm.id"
                                        class="w-full flex justify-center cursor-pointer uppercase text-white font-semibold text-center py-3 bg-slate-600 hover:bg-slate-500 rounded-lg"
                                    >
                                        MAP
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="flex pt-2">
                    <a
                        v-if="permissions && permissions.storm_manage"
                        href="/storms"
                        class="w-auto px-4 xl:px-0 xl:w-full flex justify-center cursor-pointer uppercase text-white font-semibold text-center py-1 bg-slate-400 hover:bg-slate-500 rounded-lg"
                    >
                        Manage Storms
                    </a>
                </p>
            </div>
</template>
